<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Atas</span>
      </v-row>

      <v-card class="borda" flat>
        <v-card-title>
          <span class="headline ma-3 ml-0">Ata - {{ atas.ata_codigo}}</span>
          <v-spacer></v-spacer>
          <v-tooltip top color="black">
            <template v-slot:activator="{ on }">
              <v-btn
                :loading="loading_ata"
                :disabled="loading_ata"
                icon
                outlined
                @click="ataRelatorio()"
                class="mr-2"
                v-on="on"
              >
                <v-icon color="#283480">mdi-pdf-box</v-icon>
              </v-btn>
            </template>
            <span>Exportar para PDF</span>
          </v-tooltip>
          <v-btn
            class="mr-2"
            @click="menu('comentar', atas)"
            rounded
            style="color: #283480 !important"
            outlined
          >
            <v-icon class="mr-1">mdi-comment</v-icon>
            <span>Comentar</span>
          </v-btn>
          <v-btn
            class="ml-2"
            rounded
            style="background-color: #283480  !important; color:#00FFD4  !important"
            @click="dialog_aprovar = true"
          >
            <v-icon class="mr-1">mdi-check</v-icon>
            <span v-if="podeAprovar">Aprovar ata</span>
            <span v-else>Ver quem aprovou</span>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col>
              <span class="font-weight-bold black--text">Título</span>
              <v-divider></v-divider>
              <h2 class="mt-4 black--text">{{atas.ata_titulo}}</h2>
            </v-col>
          </v-row>
          <v-row class="mt-n3">
            <v-col>
              <span class="font-weight-bold black--text">Descrição</span>
              <v-divider class="mb-4"></v-divider>
              <span class="black--text" v-html="atas.ata_descricao"></span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <h1 class="ma-3 ml-0" v-if="comentarios.length > 0">Comentários</h1>
      <v-row class="ml-1 mt-n4" v-for="(item, index) in comentarios" :key="index">
        <v-col md="auto" sm="auto" cols="auto">
          <v-row align="center">
            <v-avatar size="64" v-if="imgAWS(item.usuario)">
              <img :src="getHash(item.usuario)" :lazy-src="getHash(item.usuario)" />
            </v-avatar>
            <v-avatar size="64" color="#283480" v-if="!item.usuario.usuario_imagem">
              <span
                class="white--text headline text-uppercase"
              >{{item.usuario.usuario_nome.charAt(0)}}</span>
            </v-avatar>
            <v-avatar size="64" v-else-if="!imgAWS(item.usuario)">
              <img :src="item.usuario.usuario_imagem" :lazy-src="item.usuario.usuario_imagem" />
            </v-avatar>
            <v-card outlined flat max-width="92%" class="borda ml-6 mt-2">
              <v-card-title class="pb-0">
                <span>{{ item.usuario.usuario_nome }}</span>
                <v-spacer></v-spacer>
                <span
                  class="black--text ml-2"
                  style="font-weight: normal; font-size: 13px"
                >{{item.created_at | moment('L')}}</span>
                <span
                  class="black--text ml-1"
                  style="font-weight: normal; font-size: 13px"
                >{{item.created_at | moment('LT')}}</span>
              </v-card-title>
              <v-card-text>
                <span
                  style="font-size: 15px !important;"
                  class="black--text"
                >{{item.ata_comentario}}</span>
              </v-card-text>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <!-- Fazer comentario -->
      <v-dialog v-model="dialog_comentario" scrollable width="500">
        <v-form ref="formComentario" v-model="valid" @submit.prevent="postComentario()">
          <v-card class="borda" flat>
            <v-card-title>
              <span class="headline ma-3">Comentar Ata</span>
              <v-spacer></v-spacer>
              <v-btn icon text @click="dialog_comentario = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mb-n6">
              <v-row>
                <v-col>
                  <v-textarea
                    auto-grow
                    rows="2"
                    :rules="requiredRules"
                    v-model="comentario.ata_comentario"
                    append-icon="mdi-comment"
                    outlined
                    dense
                    flat
                    solo
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row class="mb-4" no-gutters justify="center">
                <v-btn
                  class="mr-2"
                  rounded
                  style="color: #283480 !important"
                  outlined
                  @click="dialog_comentario = false"
                >
                  <span>Cancelar</span>
                </v-btn>
                <v-btn
                  class="ml-2"
                  rounded
                  @click="certeza()"
                  style="background-color: #283480  !important; color:#00FFD4  !important"
                >
                  <v-icon class="mr-1">mdi-comment</v-icon>
                  <span>Publicar comentário</span>
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
          <v-dialog v-model="dialog_ctz_publicar" persistent max-width="550">
            <v-card class="borda" flat>
              <v-card-title class="headline">Ação Irreversível</v-card-title>
              <v-card-text
                style="text-align: justify; text-justify: inter-word;"
              >Ao publicar o comentário o mesmo não poderá ser editado ou excluído, tem certeza que deseja publicar o comentário?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  :disabled="loadingComentario"
                  rounded
                  color="#283480"
                  @click="dialog_ctz_publicar = false"
                >Cancelar</v-btn>
                <v-btn
                  style="background-color: #283480  !important; color:#00FFD4  !important"
                  rounded
                  :loading="loadingComentario"
                  :disabled="loadingComentario"
                  @click="postComentario()"
                >Sim, tenho certeza</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialog_aprovar" scrollable width="500">
        <v-card class="borda" flat>
          <v-card-title>
            <span class="headline ma-3">Aprovar Ata</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="dialog_aprovar = false">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mb-n6">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Usuário</th>
                    <th class="text-left">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in aprovacoes" :key="index">
                    <td>
                      <v-avatar size="32" v-if="imgAWS(item.usuario)">
                        <img :src="getHash(item.usuario)" :lazy-src="getHash(item.usuario)" />
                      </v-avatar>
                      <v-avatar size="32" color="#283480" v-if="!item.usuario.usuario_imagem">
                        <span
                          class="white--text headline text-uppercase"
                        >{{item.usuario.usuario_nome.charAt(0)}}</span>
                      </v-avatar>
                      <v-avatar size="32" v-else-if="!imgAWS(item.usuario)">
                        <img
                          :src="item.usuario.usuario_imagem"
                          :lazy-src="item.usuario.usuario_imagem"
                        />
                      </v-avatar>
                      <span class="ml-1">{{ item.usuario.usuario_nome }}</span>
                      <v-spacer></v-spacer>
                    </td>
                    <td>
                      <strong v-if="item.ata_aprovada == 0" class="red--text">
                        <v-icon color="red">mdi-close</v-icon>Não aprovado
                      </strong>
                      <strong v-if="item.ata_aprovada == 1" class="green--text">
                        <v-icon color="green">mdi-check</v-icon>Aprovado
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                rounded
                style="color: #283480 !important"
                outlined
                @click="dialog_aprovar = false"
              >
                <span>Cancelar</span>
              </v-btn>
              <v-btn
                class="ml-2"
                rounded
                v-if="podeAprovar"
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="certezaAprovar()"
              >
                <v-icon class="mr-1">mdi-check</v-icon>
                <span>Aprovar Ata</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_ctz_aprovar" persistent max-width="550">
        <v-card class="borda" flat>
          <v-card-title class="headline">Ação Irreversível</v-card-title>
          <v-card-text
            style="text-align: justify; text-justify: inter-word;"
          >Ao aprovar a Ata essa ação não poderá ser revertida, tem certeza que deseja aprovar a Ata?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              :disabled="loadingComentario"
              rounded
              color="#283480"
              @click="dialog_ctz_publicar = false"
            >Cancelar</v-btn>
            <v-btn
              style="background-color: #283480  !important; color:#00FFD4  !important"
              rounded
              :loading="loadingComentario"
              :disabled="loadingComentario"
              @click="aprovarAta()"
            >Sim, tenho certeza</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      dialog_ctz_aprovar: false,
      dialog_aprovar: false,
      atas: {
        ata_titulo: "Buscando informações...",
        ata_descricao: "",
        ata_codigo: ""
      },
      requiredRules: [v => !!v || "Campo Obrigatório."],
      valid: true,
      menu_ata: false,
      editModulo: false,
      dialog_ata: false,
      dialog_comentario: false,
      comentarios: [],
      comentario: {
        ata_comentario: "",
        fk_id_ata: ""
      },
      aprovacoes: [],
      podeAprovar: false,
      loadingComentario: false,
      dialog_ctz_publicar: false,
      loading_ata: false,
      link_relatorio: ""
    };
  },
  created() {
    this.validaEdicaoModulo();
    this.getAta();
    this.getUsuario();
  },

  methods: {
    getHash(item) {
      let url =
        Api.getApUrl() +
        "/usuarios/imagem/show?img=" +
        item.usuario_imagem_hash;
      return url;
    },
    imgAWS(item) {
      if (item.usuario_imagem) {
        if (item.usuario_imagem.indexOf("amazonaws.com/") != -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    erroImg() {
      return `<span class="white--text headline text-uppercase">{{item.usuario.usuario_nome.charAt(0)}}</span>`;
    },
    certeza() {
      if (this.$refs.formComentario.validate()) {
        this.dialog_ctz_publicar = true;
      }
    },
    certezaAprovar() {
      this.dialog_ctz_aprovar = true;
    },
    userLeft(item) {
      if (this.user.id_usuario == item.fk_id_usuario) {
        return true;
      } else {
        return false;
      }
    },
    aprovado() {
      for (let i = 0; i < this.aprovacoes.length; i++) {
        if (this.aprovacoes[i].fk_id_usuario == this.user.id_usuario) {
          if (this.aprovacoes[i].ata_aprovada == 0) {
            this.podeAprovar = true;
          }
        }
      }
    },
    ataRelatorio() {
      this.loading_ata = true;
      Api.get(
        "/atas/ataPDF?id_ata=" +
          this.atas.id_ata +
          "&user=" +
          localStorage.getItem("user-token")
      )
        .then(response => {
          if (response) {
            let file = response.data.link;
            this.link_relatorio = response.data.link;
            let link = document.createElement("a");
            link.href = file;
            link.download = "Ata_" + this.atas.ata_codigo + ".pdf";
            link.target = "_blank";
            link.click();
            this.loading_ata = false;
          }
          this.loading_ata = false;
        })
        .catch(err => {
          this.loading_ata = false;
          throw err;
        });
    },
    aprovarAta() {
      if (this.podeAprovar) {
        this.loadingComentario = true;
        Api.post(
          "/atas/aprovarAta?id=" +
            this.atas.id_ata +
            "&user_id=" +
            this.user.id_usuario
        )
          .then(response => {
            if (response) {
              this.podeAprovar = false;
              this.$toast.success("Ata aprovada por sucesso!");
              this.dialog_ctz_aprovar = false;
              this.getAprovacoes();
            }
            this.loadingComentario = false;
          })
          .catch(err => {
            this.loadingComentario = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },
    getUsuario() {
      let usuario = localStorage.getItem("user-token");
      Api.get("/atas/getUser/" + usuario)
        .then(response => {
          if (response) {
            this.user = response.data;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error("Oops! Ocorreu um erro.");
          throw err;
        });
    },
    getAprovacoes() {
      Api.get("/atas/aprovacoes?id_ata=" + this.atas.id_ata)
        .then(response => {
          if (response) {
            this.aprovacoes = response.data;
            this.aprovado();
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error("Oops! Ocorreu um erro.");
          throw err;
        });
    },
    getComentario() {
      Api.get("/atas/comentario?id_ata=" + this.atas.id_ata)
        .then(response => {
          if (response) {
            this.comentarios = response.data.data;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error("Oops! Ocorreu um erro.");
          throw err;
        });
    },
    getAta() {
      Api.get("/atas/" + this.$route.params.codigo)
        .then(response => {
          if (response) {
            this.atas = response.data;
            this.getComentario();
            this.getAprovacoes();
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error("Oops! Ocorreu um erro.");
          throw err;
        });
    },
    postComentario() {
      if (this.$refs.formComentario.validate()) {
        this.loadingComentario = true;
        Api.post("/atas/comentario", this.comentario)
          .then(response => {
            if (response) {
              this.$toast.success("Cadastrado com sucesso!");
              this.$refs.formComentario.resetValidation();
              this.getComentario();
              this.dialog_comentario = false;
              this.comentario = {
                ata_comentario: "",
                fk_id_ata: ""
              };
              this.close();
              this.loadingComentario = false;
            }
          })
          .catch(err => {
            this.loadingComentario = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },
    menu(opcao, item) {
      if (opcao == "comentar") {
        this.dialog_comentario = true;
        this.comentario.fk_id_ata = item.id_ata;
      }
    },
    close() {
      this.menu_ata = false;
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>